// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__u2Gl4","tab":"styles_tab__1ERaP","active":"styles_active__pKiYD"};